import {Component, computed, input, output} from '@angular/core';
import {Button} from 'primeng/button';
import {IconType} from '../../icon/icon';
import {mapIconTypeToPrimeIcon} from '../../icon/icon.mapper';
import {Tooltip} from 'primeng/tooltip';

export type  ButtonVariant = 'text' | 'outlined' | undefined;

@Component({
  selector: 'elcia-button',
  imports: [Button, Tooltip],
  templateUrl: './button.html',
  styleUrl: './button.scss'
})

export class ElciaButton {
  tooltip = input<string>();
  label = input<string>();
  icon = input<IconType>();
  disabled = input<boolean>(false);
  severity = input<ButtonSeverity>('primary');
  variant = input<ButtonVariant>(undefined);
  onClick = output<any>();

  size = input<'small' | 'large' | undefined>(undefined);

  primeIcon = computed(() => {
    const iconType = this.icon();
    if (!iconType) return undefined;

    const icon = mapIconTypeToPrimeIcon(iconType);
    if (icon) return `pi ${icon}`
    return ''
  });
  isLoading = input(false);

  protected onClicked(event: PointerEvent) {
    this.onClick.emit(event);
  }
}

export type ButtonSeverity =
  'primary'
  | 'secondary'
  | 'success'
  | 'info'
  | 'warn'
  | 'danger'
  | 'help'
  | 'contrast'
  | undefined;
